import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export var BINARY_GENDERS = ["male", "female", "undisclosed"];
var MASKED_GENDER = "undisclosed";
export function getGender(_ref) {
  var gender = _ref.gender,
    flag = _ref.flag;
  if (flag && !_includesInstanceProperty(BINARY_GENDERS).call(BINARY_GENDERS, gender)) {
    return MASKED_GENDER;
  }
  return gender;
}
export function canEditGender(_ref2) {
  var gender = _ref2.gender,
    flag = _ref2.flag;
  if (flag && !_includesInstanceProperty(BINARY_GENDERS).call(BINARY_GENDERS, gender)) {
    return false;
  }
  return true;
}
//# sourceMappingURL=gender.js.map